/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { ForgotPassword } from './components/ForgotPassword';
import { ConfirmPassword } from './components/ConfirmPassword';
import { WalletConfirmPassword } from './components/WalletConfirmPassword';
import { Login } from './components/Login';
import { toAbsoluteUrl } from '../../../rbts/helpers';

export function AuthPage() {
  useEffect(() => {
    return () => {};
  }, []);

  return (
    <>
      <Helmet>
        <title>Ticketcash</title>
      </Helmet>
      <div
        className="d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed"
        // style={{
        //   backgroundImage: `url(${toAbsoluteUrl(
        //     '/media/illustrations/sketchy-1/14.png'
        //   )})`,
        // }}
      >
        {/* begin::Content */}
        <div className="d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20">
          {/* begin::Logo */}
          <a href="#" className="mb-12">
            <img
              alt="Logo"
              src={toAbsoluteUrl('/media/logos/logtickett.png')}
              style={{ height: '130px' }}
            />
          </a>
          {/* end::Logo */}
          {/* begin::Wrapper */}
          <div className="w-lg-500px rounded p-10 p-lg-15 mx-auto" style={{ backgroundColor: 'var(--tc-bg-surface)', boxShadow: '0 8px 40px rgba(0,0,0,0.5)', border: '1px solid var(--tc-border)' }}>
            <Switch>
              <Route path="/auth/login" component={Login} />
              <Route path="/auth/confirm-password/:token" component={ConfirmPassword} />
              <Route path="/auth/wallet/confirm-password/:token" component={WalletConfirmPassword} />
              <Route path="/auth/forgot-password" component={ForgotPassword} />
              <Redirect from="/auth" exact={true} to="/auth/login" />
              <Redirect to="/auth/login" />
            </Switch>
          </div>
          {/* end::Wrapper */}
        </div>
        {/* end::Content */}
        {/* begin::Footer */}
        <div className="d-flex flex-center flex-column-auto p-10"></div>
        {/* end::Footer */}
      </div>
    </>
  );
}
